import { render, staticRenderFns } from "./CoverageDetailSinglePlots.vue?vue&type=template&id=9ed9e694"
import script from "./CoverageDetailSinglePlots.vue?vue&type=script&setup=true&lang=ts"
export * from "./CoverageDetailSinglePlots.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports